import { render, staticRenderFns } from "./akun.vue?vue&type=template&id=54c551a8"
import script from "./akun.vue?vue&type=script&lang=js"
export * from "./akun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports